import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterHTML, filterResource} from "../helpers/filters";

interface Data {
    paragraphById: {
        fieldTextDemo: Array<{
            value: string;
            format: string;
            processed: string;
        }>;
        fieldImageDemoMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: string;
                    height: string;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>;
    }
}

class TextImageQuery extends Query<Data, {id: string}> {}

const GET_TEXT_IMAGE = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphTextImage {
          fieldTextDemo {
            value
            format
            processed
          }
          fieldImageDemoMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
              }
          }
        }
      }
    }
  }
}
`;

const TextImage = ({id, markComponentLoadedAs}) => (
    <TextImageQuery asyncMode query={GET_TEXT_IMAGE} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            markComponentLoadedAs(id, true);

            return (
                <div className="textImage">

                    {field.fieldTextDemo && field.fieldTextDemo.value && (
                        // eslint-disable-next-line react/no-danger
                        <div className="textImage__content" dangerouslySetInnerHTML={{__html: filterHTML(field.fieldTextDemo.value)}} />
                    )}

                    {field.fieldImageDemoMedia && field.fieldImageDemoMedia.entity && field.fieldImageDemoMedia.entity.fieldMediaImage && field.fieldImageDemoMedia.entity.fieldMediaImage.url && (
                        <div className="textImage__image">
                            <img src={filterResource(field.fieldImageDemoMedia.entity.fieldMediaImage.url)} alt={field.fieldImageDemoMedia.entity.fieldMediaImage.title}/>
                        </div>
                    )}

                </div>
            );
        }}
    </TextImageQuery>
);

TextImage.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default TextImage;



// WEBPACK FOOTER //
// ./frontend/components/TextImage.jsx